export const removeViewParamFromUrl: () => void = () => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete('view');

  replaceSearchParamsInCurrentUrl(searchParams);
};

export const addViewParamToUrl: (value: string) => void = (value: string) => {
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.get('view')) {
    return;
  }

  searchParams.append('view', value);

  replaceSearchParamsInCurrentUrl(searchParams);
};

const replaceSearchParamsInCurrentUrl = (searchParams: URLSearchParams) => {
  window.history.replaceState &&
    window.history.replaceState(
      null,
      '',
      `${window.location.pathname}?${searchParams.toString()}`.replaceAll('%3A', ':'),
    );
};
